import {
  Box,
  Button,
  Card,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import StudentFeeDetails from '../pages/[admin]/Student/StudentFeeDetails';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { searchForStudent } from '../features/payments/PaymentSlice';
import ReusableMUITable from './UIElements/ReusableMUITable';
import CloseIcon from '@mui/icons-material/Close';
function PaymentsPage() {
  const dispatch = useDispatch();
  const [studentId, setStudentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [studentList, setStudentsList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  async function searchStudent() {
    setLoading(true);
    try {
      const response = await dispatch(searchForStudent(searchValue)).unwrap();
      if (response?.length > 1) {
        setStudentsList(response);
        setStudentId('');
      } else if (response?.length == 1) {
        setStudentId(response?.[0]?.studentId);
        setStudentsList([]);
      } else {
        setStudentId(searchValue);
        setStudentsList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box className='p-4'>
      {' '}
      <Box className='bg-blue-50 p-4 rounded-lg mb-4'>
        <Typography variant='h6' className='text-blue-700 font-bold'>
          Manage Payments
        </Typography>
        <Typography variant='body1' className='text-gray-600'>
          Search for student and manage student payments details here.
        </Typography>
      </Box>
      <Card className='max-w-5xl px-4 py-10 border'>
        <div className=' mb-4 ml-2'>
          <Typography variant='h6' className='mb-2'>
            Enter Student Id, Name, Mobile etc and manage payments detials.
          </Typography>
          <div className='flex items-center flex-wrap gap-2 mb-4 '>
            <TextField
              value={searchValue}
              id='studentId'
              size='small'
              className='w-80 mr-10'
              placeholder='StudentId, Name, Mobile etc ..'
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    {!!searchValue && (
                      <IconButton
                        onClick={() => {
                          setSearchValue('');
                          setStudentId('');
                        }}
                      >
                        <CloseIcon></CloseIcon>
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setSearchValue(e.target.value)}
            ></TextField>

            <Button
              variant='contained'
              disabled={!searchValue || loading}
              onClick={searchStudent}
            >
              {loading ? 'Searching' : 'Search'}
            </Button>
          </div>
          {studentList?.length >= 2 && (
            <ReusableMUITable
              headerNames={[
                'Student Id',
                'First Name',
                'Last Name',
                'Mobile',
                'Class',
                'Section',
                'Actions',
              ]}
              rowValues={[
                { accessValue: 'studentId' },
                { accessValue: 'firstName' },
                { accessValue: 'lastName' },
                { accessValue: 'mobileNumber' },
                { accessValue: 'departmentName' },
                { accessValue: 'className' },
                {
                  accessValue: 'studentId',
                  renderCell: (value) => (
                    <Button
                      onClick={() => {
                        setStudentId(value);
                        setStudentsList([]);
                      }}
                    >
                      Manage Payments
                    </Button>
                  ),
                },
              ]}
              dataList={studentList}
            />
          )}
        </div>
        <StudentFeeDetails StudentId={studentId} />
      </Card>
    </Box>
  );
}
export default PaymentsPage;
